var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 977.3 144.1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m0 45h47.8v94.6h48.7v-94.6h47.9v-40.5h-144.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.4 51.6h-47.6v-47.1h-48.5v135.1h48.5v-47.1h47.6v47.1h48.8v-135.1h-48.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319 139.6h124.3v-38.9h-75.7v-13h72.8v-31.2h-72.8v-13.2h75.7v-38.8h-124.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m711.3 4.5-48.7 135.1h50.2l5.1-16.2h55l5.1 16.2h50.3l-48.8-135.1zm18 83 11.9-37.3h8.4l11.9 37.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m917.4 4.5h-78.6v135.1h48.6v-27.5h30.2c37 0 59.7-16.1 59.7-53.7 0-37.8-22.7-53.9-59.9-53.9zm-4.3 67.2h-25.7v-26.8h25.9c8.8 0 14.8 4.5 14.8 13.5-.1 8.8-6 13.3-15 13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m667.2 63.8h-74.2v23.6h24.9c-4.3 10-12.8 14.6-24.4 14.6-15.6 0-28.3-11.6-28.3-30.1 0-18.7 12.7-30.1 28.3-30.1 7.3 0 13.3 1.8 17.9 5.6h52.3c-9.2-35.6-40.1-47.4-70.2-47.4-46.1 0-76.5 28.5-76.5 72.1s30.4 72.1 76.6 72.1c25.3 0 50.7-7.7 63.8-31.2 3.9-7 6.4-14.7 8.2-25.4 1.6-10.8 1.6-23.8 1.6-23.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m506.9 100.7h-48.7v38.9h75.8c-2-1.6-4-3.2-5.9-5-9.9-9.3-17-20.8-21.2-33.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a34916298787ef22a56f7d4c6d3d5feb.svg";
export { ForwardRef as ReactComponent };